module.exports = __webpack_public_path__ + "assets/f466ee6f3ce09651d71fb6e8c5d52ca0.mp3";